import * as React from 'react'
import { type IconProps } from './types'
/**
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB0PSIxNzQ0NjEyMTkxMzMxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExMjEwIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZiI+PHBhdGggZD0iTTYwMi40OTYgNjkyLjk5MmEzMiAzMiAwIDAgMSAwIDQ1LjMxMkw0NDQuMTYgODk2LjY0YTIyNCAyMjQgMCAwIDEtMzE2LjgtMzE2LjhsMTU4LjQtMTU4LjMzNmEzMiAzMiAwIDAgMSA0NS4zMTIgNDUuMjQ4TDE3Mi42MDggNjI1LjE1MmExNjAgMTYwIDAgMSAwIDIyNi4yNCAyMjYuMjRsMTU4LjQtMTU4LjRhMzIgMzIgMCAwIDEgNDUuMjQ4IDB6IG0yMi42NTYtMjk0LjE0NGEzMiAzMiAwIDAgMSAwIDQ1LjI0OEw0NDQuMDk2IDYyNS4xNTJhMzIgMzIgMCAxIDEtNDUuMjQ4LTQ1LjI0OGwxODEuMDU2LTE4MS4wNTZhMzIgMzIgMCAwIDEgNDUuMjQ4IDB6TTg5Ni42NCAxMjcuMzZhMjI0IDIyNCAwIDAgMSAwIDMxNi44bC0xNTguMzM2IDE1OC4zMzZhMzIgMzIgMCAxIDEtNDUuMzEyLTQ1LjI0OGwxNTguNC0xNTguNGExNjAgMTYwIDAgMCAwLTIyNi4yNC0yMjYuMjRMNDY2Ljc1MiAzMzEuMDA4YTMyIDMyIDAgMCAxLTQ1LjI0OC00NS4zMTJMNTc5Ljg0IDEyNy4zNmEyMjQgMjI0IDAgMCAxIDMxNi44IDB6IiBwLWlkPSIxMTIxMSI+PC9wYXRoPjwvc3ZnPg==)
 */
export const LinkIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16, ...props }, forwardedRef) => {
    return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M602.496 692.992a32 32 0 0 1 0 45.312L444.16 896.64a224 224 0 0 1-316.8-316.8l158.4-158.336a32 32 0 0 1 45.312 45.248L172.608 625.152a160 160 0 1 0 226.24 226.24l158.4-158.4a32 32 0 0 1 45.248 0z m22.656-294.144a32 32 0 0 1 0 45.248L444.096 625.152a32 32 0 1 1-45.248-45.248l181.056-181.056a32 32 0 0 1 45.248 0zM896.64 127.36a224 224 0 0 1 0 316.8l-158.336 158.336a32 32 0 1 1-45.312-45.248l158.4-158.4a160 160 0 0 0-226.24-226.24L466.752 331.008a32 32 0 0 1-45.248-45.312L579.84 127.36a224 224 0 0 1 316.8 0z"
          fill={color}
        ></path>
      </svg>
    )
  },
)
